import { mapState, mapGetters } from 'vuex';

import Snackbar from '@/components/_core/ui/snackbar/index.vue';
import ImpersonatedLayout from '@/components/_core/ui/impersonated';

export default {
  head() {
    return {
      title         : this.headTitle,
      titleTemplate : `%s :: ${process.env.APPLICATION_TITLE}`,
      meta          : [
        { name: 'theme-color', content: this.themes.light.primary },
        { name: 'msapplication-navbutton-color', content: this.themes.light.primary },
        { name: 'apple-mobile-web-app-status-bar-style', content: this.themes.light.primary }
      ]
    };
  },
  components: {
    Snackbar,
    ImpersonatedLayout
  },
  computed: {
    ...mapGetters({
      isImpersonated: '_core/auth/isImpersonated'
    }),
    ...mapState({
      themes: state => state._core.application.themes
    }),
    headTitle() {
      return this.$t('common.loading');
    }
  }
};
